module.exports = __webpack_public_path__ + "img/10877_L.4f53b8db.png";